import styled, { css } from 'styled-components';
import { rem, rgba } from 'polished';
import variables from '@styles/variables';
import NextLink from 'next/link';

export const linkStyles = css<{ $variant?: LinkVariant }>`
  font-family: ${variables.fonts.fontGothamMedium};
  text-decoration: none;
  font-size: inherit;

  ${(props) =>
    props.$variant === 'primary' &&
    css`
      color: ${variables.colors.highlight};
      &:visited {
        color: ${variables.colors.highlight};
      }
      &:hover {
        color: ${variables.colors.highlightHover};
      }
    `}

  ${(props) =>
    props.$variant === 'secondary' &&
    css`
      color: ${variables.colors.white};
      &:visited {
        color: ${variables.colors.white};
      }
      &:hover {
        color: ${rgba(variables.colors.white, 0.7)};
      }
    `}

    ${(props) =>
    props.$variant === 'nav' &&
    css`
      color: ${variables.colors.lighterBlack};
      &:visited {
        color: ${variables.colors.lighterBlack};
      }
      &:hover {
        color: ${variables.colors.primary};
      }
    `}

    ${(props) =>
    props.$variant === 'sidenav' &&
    css`
      color: ${variables.colors.lighterBlack};
      font-family: ${variables.fonts.fontGothamBook};
      font-size: ${rem(13)};
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: block;
      &:visited {
        color: ${variables.colors.lighterBlack};
      }
      @media (hover: hover) and (pointer: fine) {
        &:hover {
          color: ${variables.colors.primary};
        }
      }
    `}

  ${(props) =>
    props.$variant === 'black' &&
    css`
      color: ${variables.colors.lighterBlack};
      &:visited {
        color: ${variables.colors.lighterBlack};
      }
      &:hover {
        color: ${rgba(variables.colors.lighterBlack, 0.8)};
      }
    `}

  ${(props) =>
    props.$variant === 'darkGrey' &&
    css`
      color: ${variables.colors.darkerGray};
      &:visited {
        color: ${variables.colors.darkerGray};
      }
      &:hover {
        color: ${rgba(variables.colors.darkerGray, 0.5)};
      }
    `}

    ${(props) =>
    props.$variant === 'white' &&
    css`
      color: ${variables.colors.white};
      &:visited {
        color: ${variables.colors.white};
      }
      &:hover {
        color: ${rgba(variables.colors.white, 0.8)};
      }
    `}
`;

export const StyledNextLink = styled(NextLink)<{ $variant?: LinkVariant }>`
  ${linkStyles}
`;

export const StyledAnchor = styled.a<{ $variant?: LinkVariant }>`
  ${linkStyles}
`;
